/* eslint-disable import/no-unresolved */
import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import axios from 'axios';
import { selectAuth } from '@/store/selectors';
import { useFetchPosProfileDetails } from '@/services/hooks/user';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const fetcher = ({ queryKey }: any) => {
  const url = queryKey[1];
  const posProfile = queryKey[2];
  const priceList = queryKey[3];
  const itemGroup = queryKey[4];
  const response = axios
    .get(
      `https://${url}/api/method/oyasync_integrations.oyasync_integrations.api.pos_app.pos_app.get_items?start=0&page_length=40&price_list=${priceList}&item_group=${itemGroup}&pos_profile=${posProfile}`,
      {
        withCredentials: true,
      },
    )
    .then((data) => data.data?.message?.items)
    .catch((error) => error.response.message);

  return response;
};

// eslint-disable-next-line import/prefer-default-export
export const useFetchItems = (itemGroup: string) => {
  const { url, posProfile } = useSelector(selectAuth);
  const { data } = useFetchPosProfileDetails();
  const priceList = data?.selling_price_list;
  return useQuery(['items', url, posProfile, priceList, itemGroup], fetcher, {
    enabled: !!priceList,
  });
};
